import React from "react";

import { DomainVerificationBlock as Value } from "@reactivated";

export const DomainVerificationBlock = (props: {
    id: string;
    value: Value;
}): React.JSX.Element | null => {
    if (!props.value.type || !props.value.value) {
        return null;
    }
    return (
        <meta
            key={props.id}
            name={props.value.type}
            content={props.value.value}
        />
    );
};
